import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <p className="footer__copyright">© 2021 Around The U.S.</p>
    </footer>
  );
}
